import { Input } from "@/components/ui/input";

interface InlineDateInputProps {
  date: string;
  label: string;
  onDateChange: (date: string) => void;
  onLabelChange: (label: string) => void;
}

const DATE_LABEL_SUGGESTIONS = ["Birthday", "Anniversary", "Kid's Birthday"];

export function InlineDateInput({
  date,
  label,
  onDateChange,
  onLabelChange,
}: InlineDateInputProps) {
  return (
    <div className="flex items-center gap-2">
      <Input
        type="date"
        value={date}
        onChange={(e) => onDateChange(e.target.value)}
        className="h-7 text-xs flex-1"
      />
      <div className="flex-1">
        <Input
          type="text"
          value={label}
          onChange={(e) => onLabelChange(e.target.value)}
          placeholder="Birthday"
          list="date-label-suggestions"
          className="h-7 text-xs"
        />
        <datalist id="date-label-suggestions">
          {DATE_LABEL_SUGGESTIONS.map((suggestion) => (
            <option key={suggestion} value={suggestion} />
          ))}
        </datalist>
      </div>
    </div>
  );
}
